import React from "react"

export default()=><footer>
© {new Date().getFullYear()}, Michael Romero
contact form
</footer>